import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-login-report',
  templateUrl: './login-report.component.html',
  styleUrls: ['./login-report.component.scss']
})
export class LoginReportComponent implements OnInit {

  displayedColumns: string[] = ['name', 'records'];
  columnsDisplayName = {
    name: 'Logins',
    records: 'Quantidade de Usuários'
  }
  submiting: boolean = false;
  datasource: MatTableDataSource<any> = new MatTableDataSource<any>()
  pieChartData: any;

  constructor(
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snapshat: MatSnackBar
  ) { }

  ngOnInit(): void {
    const subject = new Subject<any>();
    subject.subscribe(({ trigger, scope }: any) => {
      if (scope == 'analytics:logins') {
        this.submiting = trigger == 'pre';
      }
    })
    this.http.setLoadingIndicator(subject, 'analytics:logins')
  }

  getLogins() {

    this.http.list('analytics:logins')
      .subscribe(
        (logins: any) => {

          if (logins.length) {
            this.datasource.data = [
              {
                records: logins[0].records,
                name: 'Único login'
              },
              {
                records: logins[1].records,
                name: 'Mais de 2 logins'
              },
            ];
            this.pieChartData = [
              {
                value: logins[0].records,
                name: 'Único login'
              },
              {
                value: logins[1].records,
                name: 'Mais de 2 logins'
              },
            ]
          }

        }
      )

  }

}
